import ContentPasteIcon from '@mui/icons-material/ContentPaste'
const Icon = () => {
  return (
    <ContentPasteIcon
      htmlColor='#E62E30'
      fontSize='large'
    />
  )
}

export default Icon
